import { render, staticRenderFns } from "./DropDownShop.vue?vue&type=template&id=28281766&"
import script from "./DropDownShop.vue?vue&type=script&lang=js&"
export * from "./DropDownShop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports